import { atom } from 'recoil';

import { FilterModalTypes } from '../../components/FilterModal';

import { TransactionFlowAvailableFilter } from './constants';
import { ProductTransactionFlow } from './types';

export type TransactionFlowProduct = {
  product: ProductTransactionFlow;
  data: { details: any[] } | null;
};

export type TransactionFlowProductState = {
  [productKey: string]: TransactionFlowProduct;
};

export const selectedTransactionFlowProduct = atom<TransactionFlowProductState>({
  key: 'TransactionFlow/SelectedProduct',
  default: {},
});

export const historicalSearchFiltersState = atom<FilterModalTypes.FilterAtom>({
  key: 'historicalSearchFiltersState',
  default: {
    availableFilters: TransactionFlowAvailableFilter,
    selectedFilters: [],
    appliedFilters: [],
  },
});
